import { RootState } from 'store/index';
import createResourceListSelectors from 'store/ResourceListSelectors';
import { PartnerState, ResourceListSelectors } from 'typings/state';

const selectors: ResourceListSelectors = createResourceListSelectors((state: RootState): PartnerState => state.partner);

export default selectors;
